import { Route, Router, useLocation } from '@solidjs/router';
import { Match, Switch, type ParentProps } from 'solid-js';
import { render } from 'solid-js/web';
import { Shell } from './components/Shell';
import { bootstrap, state } from './lib/app';
import AuthCallback from './pages/AuthCallback';
import BookmarksPage from './pages/Bookmarks';
import DevicesPage from './pages/Devices';
import ExtensionsPage from './pages/Extensions';
import NotFound from './pages/NotFound';
import SignIn from './pages/SignIn';
import './styles.css';

function Root(props: ParentProps) {
  const location = useLocation();
  return (
    <Switch fallback={<Shell>{props.children}</Shell>}>
      <Match when={location.pathname === '/auth/callback' && !state.session()}>
        <AuthCallback />
      </Match>
      <Match when={state.session() === undefined}>
        <div class="splash" aria-busy="true">
          <div class="ribbon syncing" />
        </div>
      </Match>
      <Match when={state.session() === null}>
        <SignIn />
      </Match>
    </Switch>
  );
}

void bootstrap();

render(
  () => (
    <Router root={Root}>
      <Route path="/" component={BookmarksPage} />
      <Route path="/extensions" component={ExtensionsPage} />
      <Route path="/devices" component={DevicesPage} />
      <Route path="/auth/callback" component={AuthCallback} />
      <Route path="*" component={NotFound} />
    </Router>
  ),
  document.getElementById('root')!,
);
